import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  GROUP,
  Language,
  createTranslatedText,
  type TranslatedText,
} from "./translatedTextGenerators.ts";

// Common translations
export const COMMON_SAVE = createTranslatedText(
  GROUP.COMMON,
  "save",
  "Save",
  "Simpan",
);

export const COMMON_CANCEL = createTranslatedText(
  GROUP.COMMON,
  "cancel",
  "Cancel",
  "Batal",
);

export const COMMON_CLOSE = createTranslatedText(
  GROUP.COMMON,
  "close",
  "Close",
  "Tutup",
);

export const COMMON_CONFIRM = createTranslatedText(
  GROUP.COMMON,
  "confirm",
  "Confirm",
  "Konfirmasi",
);

export const COMMON_DELETE = createTranslatedText(
  GROUP.COMMON,
  "delete",
  "Delete",
  "Hapus",
);

export const COMMON_EDIT = createTranslatedText(
  GROUP.COMMON,
  "edit",
  "Edit",
  "Edit",
);

export const COMMON_SUCCESS = createTranslatedText(
  GROUP.COMMON,
  "success",
  "Success",
  "Sukses",
);

export const COMMON_ERROR = createTranslatedText(
  GROUP.COMMON,
  "error",
  "Error",
  "Kesalahan",
);

export const COMMON_LOADING = createTranslatedText(
  GROUP.COMMON,
  "loading",
  "Loading...",
  "Memuat...",
);

export const COMMON_SEARCH = createTranslatedText(
  GROUP.COMMON,
  "search",
  "Search",
  "Cari",
);

export const COMMON_NODATA = createTranslatedText(
  GROUP.COMMON,
  "nodata",
  "No Data Available",
  "Tidak Ada Data Tersedia",
);

export const COMMON_WELCOME = createTranslatedText(
  GROUP.COMMON,
  "welcome",
  "Welcome",
  "Selamat Datang",
);

export const COMMON_LOADING_CONTACTS = createTranslatedText(
  GROUP.COMMON,
  "loadingContacts",
  "Loading contacts...",
  "Memuat kontak...",
);

export const COMMON_NO_CONTACTS = createTranslatedText(
  GROUP.COMMON,
  "noContacts",
  "No contacts available",
  "Tidak ada kontak tersedia",
);

export const COMMON_RETRY = createTranslatedText(
  GROUP.COMMON,
  "retry",
  "Retry",
  "Coba Lagi",
);

export const COMMON_MICROPHONE_ACCESS_REQUIRED = createTranslatedText(
  GROUP.COMMON,
  "microphoneAccessRequired",
  "Microphone access is required for calls",
  "Akses mikrofon diperlukan untuk panggilan",
);

export const COMMON_GRANT_ACCESS = createTranslatedText(
  GROUP.COMMON,
  "grantAccess",
  "Grant Access",
  "Berikan Akses",
);

export const COMMON_CONNECTED = createTranslatedText(
  GROUP.COMMON,
  "connected",
  "Connected",
  "Terhubung",
);

export const COMMON_DISCONNECTED = createTranslatedText(
  GROUP.COMMON,
  "disconnected",
  "Disconnected",
  "Terputus",
);

// Header translations
export const HEADER_TITLE = createTranslatedText(
  GROUP.HEADER,
  "title",
  "STE Web App",
  "Aplikasi Web STE",
);

export const HEADER_LOGOUT = createTranslatedText(
  GROUP.HEADER,
  "logout",
  "Logout",
  "Keluar",
);

export const HEADER_SETTINGS = createTranslatedText(
  GROUP.HEADER,
  "settings",
  "Settings",
  "Pengaturan",
);

// Dialer translations
export const DIALER_TITLE = createTranslatedText(
  GROUP.DIALER,
  "title",
  "Dialer",
  "Dialer",
);

export const DIALER_PLACEHOLDER = createTranslatedText(
  GROUP.DIALER,
  "placeholder",
  "Enter phone number",
  "Masukkan nomor telepon",
);

export const DIALER_CALL = createTranslatedText(
  GROUP.DIALER,
  "call",
  "Call",
  "Panggil",
);

export const DIALER_HANGUP = createTranslatedText(
  GROUP.DIALER,
  "hangup",
  "Hang Up",
  "Tutup",
);

export const DIALER_MUTE = createTranslatedText(
  GROUP.DIALER,
  "mute",
  "Mute",
  "Bisukan",
);

export const DIALER_UNMUTE = createTranslatedText(
  GROUP.DIALER,
  "unmute",
  "Unmute",
  "Bunyikan",
);

export const DIALER_HOLD = createTranslatedText(
  GROUP.DIALER,
  "hold",
  "Hold",
  "Tahan",
);

export const DIALER_UNHOLD = createTranslatedText(
  GROUP.DIALER,
  "unhold",
  "Unhold",
  "Lepas Tahan",
);

export const DIALER_TRANSFER = createTranslatedText(
  GROUP.DIALER,
  "transfer",
  "Transfer",
  "Transfer",
);

export const DIALER_KEYPAD = createTranslatedText(
  GROUP.DIALER,
  "keypad",
  "Keypad",
  "Keypad",
);

// Call translations
export const CALL_INCOMING = createTranslatedText(
  GROUP.CALL,
  "incoming",
  "Incoming Call",
  "Panggilan Masuk",
);

export const CALL_OUTGOING = createTranslatedText(
  GROUP.CALL,
  "outgoing",
  "Outgoing Call",
  "Panggilan Keluar",
);

export const CALL_DURATION = createTranslatedText(
  GROUP.CALL,
  "duration",
  "Duration",
  "Durasi",
);

export const CALL_ANSWERED = createTranslatedText(
  GROUP.CALL,
  "answered",
  "Answered",
  "Dijawab",
);

export const CALL_MISSED = createTranslatedText(
  GROUP.CALL,
  "missed",
  "Missed",
  "Tidak Terjawab",
);

export const CALL_REJECTED = createTranslatedText(
  GROUP.CALL,
  "rejected",
  "Rejected",
  "Ditolak",
);

export const CALL_ENDED = createTranslatedText(
  GROUP.CALL,
  "ended",
  "Call Ended",
  "Panggilan Berakhir",
);

export const CALL_CONNECTING = createTranslatedText(
  GROUP.CALL,
  "connecting",
  "Connecting...",
  "Menghubungkan...",
);

export const CALL_RINGING = createTranslatedText(
  GROUP.CALL,
  "ringing",
  "Ringing...",
  "Berdering...",
);

export const CALL_ON_HOLD = createTranslatedText(
  GROUP.CALL,
  "onHold",
  "On Hold",
  "Ditahan",
);

export const CALL_ANSWER = createTranslatedText(
  GROUP.CALL,
  "answer",
  "Answer",
  "Jawab",
);

export const CALL_DECLINE = createTranslatedText(
  GROUP.CALL,
  "decline",
  "Decline",
  "Tolak",
);

// Settings translations
export const SETTINGS_TITLE = createTranslatedText(
  GROUP.SETTINGS,
  "title",
  "Settings",
  "Pengaturan",
);

export const SETTINGS_LANGUAGE = createTranslatedText(
  GROUP.SETTINGS,
  "language",
  "Language",
  "Bahasa",
);

export const SETTINGS_AUDIO = createTranslatedText(
  GROUP.SETTINGS,
  "audio",
  "Audio Settings",
  "Pengaturan Audio",
);

export const SETTINGS_MICROPHONE = createTranslatedText(
  GROUP.SETTINGS,
  "microphone",
  "Microphone",
  "Mikrofon",
);

export const SETTINGS_SPEAKER = createTranslatedText(
  GROUP.SETTINGS,
  "speaker",
  "Speaker",
  "Pengeras Suara",
);

export const SETTINGS_RINGTONE = createTranslatedText(
  GROUP.SETTINGS,
  "ringtone",
  "Ringtone",
  "Nada Dering",
);

// Auth translations
export const AUTH_LOGIN = createTranslatedText(
  GROUP.AUTH,
  "login",
  "Login",
  "Masuk",
);

export const AUTH_LOGOUT = createTranslatedText(
  GROUP.AUTH,
  "logout",
  "Logout",
  "Keluar",
);

export const AUTH_EMAIL = createTranslatedText(
  GROUP.AUTH,
  "email",
  "Email",
  "Email",
);

export const AUTH_PASSWORD = createTranslatedText(
  GROUP.AUTH,
  "password",
  "Password",
  "Kata Sandi",
);

export const AUTH_FORGOT_PASSWORD = createTranslatedText(
  GROUP.AUTH,
  "forgotPassword",
  "Forgot Password?",
  "Lupa Kata Sandi?",
);

export const AUTH_LOGIN_ERROR = createTranslatedText(
  GROUP.AUTH,
  "loginError",
  "Login failed. Please check your credentials.",
  "Login gagal. Periksa kredensial Anda.",
);

// Error translations
export const ERRORS_GENERIC = createTranslatedText(
  GROUP.ERRORS,
  "generic",
  "Something went wrong. Please try again.",
  "Terjadi kesalahan. Silakan coba lagi.",
);

export const ERRORS_NETWORK = createTranslatedText(
  GROUP.ERRORS,
  "network",
  "Network error. Please check your connection.",
  "Kesalahan jaringan. Periksa koneksi Anda.",
);

export const ERRORS_CALL_FAILED = createTranslatedText(
  GROUP.ERRORS,
  "callFailed",
  "Call failed. Please try again.",
  "Panggilan gagal. Silakan coba lagi.",
);

export const ERRORS_PERMISSION_DENIED = createTranslatedText(
  GROUP.ERRORS,
  "permissionDenied",
  "Microphone permission denied.",
  "Izin mikrofon ditolak.",
);

// All translations array for generating translation objects
const allTranslations: TranslatedText[] = [
  // Common
  COMMON_SAVE,
  COMMON_CANCEL,
  COMMON_CLOSE,
  COMMON_CONFIRM,
  COMMON_DELETE,
  COMMON_EDIT,
  COMMON_SUCCESS,
  COMMON_ERROR,
  COMMON_LOADING,
  COMMON_SEARCH,
  COMMON_NODATA,
  COMMON_WELCOME,
  COMMON_LOADING_CONTACTS,
  COMMON_NO_CONTACTS,
  COMMON_RETRY,
  COMMON_MICROPHONE_ACCESS_REQUIRED,
  COMMON_GRANT_ACCESS,
  COMMON_CONNECTED,
  COMMON_DISCONNECTED,
  // Header
  HEADER_TITLE,
  HEADER_LOGOUT,
  HEADER_SETTINGS,
  // Dialer
  DIALER_TITLE,
  DIALER_PLACEHOLDER,
  DIALER_CALL,
  DIALER_HANGUP,
  DIALER_MUTE,
  DIALER_UNMUTE,
  DIALER_HOLD,
  DIALER_UNHOLD,
  DIALER_TRANSFER,
  DIALER_KEYPAD,
  // Call
  CALL_INCOMING,
  CALL_OUTGOING,
  CALL_DURATION,
  CALL_ANSWERED,
  CALL_MISSED,
  CALL_REJECTED,
  CALL_ENDED,
  CALL_CONNECTING,
  CALL_RINGING,
  CALL_ON_HOLD,
  CALL_ANSWER,
  CALL_DECLINE,
  // Settings
  SETTINGS_TITLE,
  SETTINGS_LANGUAGE,
  SETTINGS_AUDIO,
  SETTINGS_MICROPHONE,
  SETTINGS_SPEAKER,
  SETTINGS_RINGTONE,
  // Auth
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_EMAIL,
  AUTH_PASSWORD,
  AUTH_FORGOT_PASSWORD,
  AUTH_LOGIN_ERROR,
  // Errors
  ERRORS_GENERIC,
  ERRORS_NETWORK,
  ERRORS_CALL_FAILED,
  ERRORS_PERMISSION_DENIED,
];

// Generate translation object
function generateTranslationObject(lang: Language): Record<string, unknown> {
  const result: Record<string, unknown> = {};

  allTranslations.forEach((text) => {
    let current = result;

    // Use group as a single key (no nesting)
    current[text.group] = current[text.group] || {};
    current = current[text.group] as Record<string, unknown>;

    // Handle nesting in placeholderText
    const placeholderParts = text.placeholderText.split(".");
    placeholderParts.forEach((part, i) => {
      if (i === placeholderParts.length - 1) {
        // Set the translation value at the last part
        current[part] =
          lang === Language.English ? text.english : text.indonesian;
      } else {
        // Create nested object for intermediate parts
        current[part] = current[part] || {};
        current = current[part] as Record<string, unknown>;
      }
    });
  });

  return result;
}

// Initialize i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.DEV,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: generateTranslationObject(Language.English) },
      id: { translation: generateTranslationObject(Language.Indonesian) },
    },
  });

export default i18n;
